import type { ReactNode } from "react";
import { cn } from "@rosette/ts/src/util/cn.js";


interface FormMessageProps {
    kind: "error" | "success";
    className?: string;
    children?: ReactNode;
}


/**
 * A validation or result message beneath a form field. It keeps its
 * one-line height while empty, so the form does not jump as it fills.
 */
export function FormMessage({ kind, className, children }: FormMessageProps) {
    return (
        <p className={cn(
            "mt-1 mb-2 min-h-[1em] text-base leading-[1em]",
            kind === "error" ? "text-danger-strong" : null,
            className ?? null,
        )}>
            {children}
        </p>
    );
}
